// extracted by mini-css-extract-plugin
export default {"checkoutIdMeBox":"IdMeToggle-module_checkoutIdMeBox_X_1UZ0eD7O"};